import { createContext } from 'preact';
import { ReactNode } from 'preact/compat';
import { useContext, useMemo } from 'preact/hooks';

export interface ABTestProviderProps {
  experiment: string;
  variant: string;
  children: ReactNode;
}

export type ABTestContextValue = {
  [key in string]?: string;
};

export const ABTestContext = createContext<ABTestContextValue>({});

export const ABTestProvider = ({ experiment, variant, children }: ABTestProviderProps) => {
  const parentContext = useContext(ABTestContext);
  const updatedContext = useMemo(() => ({ ...parentContext, [experiment]: variant }), [experiment, parentContext, variant]);
  if (experiment in parentContext) {
    // Since we have a parent context, we can check if the variant matches
    if (parentContext[experiment] === variant) {
      // If the variant matches, we can just return the children
      return <>{children}</>;
    }
    // If the variant doesn't match, we throw an error since variant mismatch is not allowed
    throw new Error(`Experiment variant mismatch: ${experiment} - parent (${parentContext[experiment]}) vs ${variant}`);
  }
  return <ABTestContext.Provider value={updatedContext}>{children}</ABTestContext.Provider>;
};
